import { useNavigate } from "react-router-dom";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg"; 
import useCustomerForm from "../../Lib/useCustomerForm";
import useFetchFundingSources from "../../Lib/useFetchFundingSources";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useState, useRef, useEffect } from "react";
import "./Customeractivation.css";

const Customeractivationpage1 = () => {
  const { formDatas, handleInputChange, handleFormSubmit } = useCustomerForm();
  const navigate = useNavigate();
  const { data: fundingSourcesData, isLoading: isFetchingFundingSources } = useFetchFundingSources();
  
  // State to store the full phone numbers with country codes
  const [phoneNumber, setPhoneNumber] = useState('');
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState('');
  
  // State for custom funding source dropdown
  const [isFundingSourceOpen, setIsFundingSourceOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const fundingSourceRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fundingSourceRef.current && !fundingSourceRef.current.contains(event.target)) {
        setIsFundingSourceOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle phone input changes
  const handlePhoneChange = (value, country) => {
    setPhoneNumber(value);
    // Extract only the number part without country code for backend
    const numberOnly = value.replace(`+${country.dialCode}`, '');
    // Update the form data with just the number
    handleInputChange({
      target: {
        name: 'phoneNumber',
        value: numberOnly
      }
    });
  };

  // Handle additional phone input changes
  const handleAdditionalPhoneChange = (value, country) => {
    setAdditionalPhoneNumber(value);
    // Extract only the number part without country code for backend
    const numberOnly = value.replace(`+${country.dialCode}`, '');
    // Update the form data with just the number
    handleInputChange({
      target: {
        name: 'additionalPhoneNumber',
        value: numberOnly
      }
    });
  };

  // Handle funding source selection
  const handleFundingSourceSelect = (source) => {
    // Update form data
    handleInputChange({
      target: {
        name: 'fundingSource',
        value: source
      }
    });
    
    // Close dropdown and reset search
    setIsFundingSourceOpen(false);
    setSearchTerm('');
    
    // Force state update
    setTimeout(() => {
      setIsFundingSourceOpen(false);
    }, 0);
  };

  // Toggle funding source dropdown
  const toggleFundingSourceDropdown = () => {
    setIsFundingSourceOpen(!isFundingSourceOpen);
  };

  // Filter funding sources based on search term
  const filteredFundingSources = Array.isArray(fundingSourcesData?.data) 
    ? fundingSourcesData.data.filter(source => 
        source.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  return (
    <div className="customer-active-container">
      <div className="wrap">
      <div className="header">
        <button onClick={() => navigate("/typeofupdate")}>Back</button>
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <button className="finished">Next</button>
      </div>
      </div>
      <form onSubmit={handleFormSubmit}>
        <h2>Company Details</h2>
        <label>
          Company Name
          <input
            type="text"
            placeholder="Enter Company Name"
            name="companyName"
            value={formDatas.companyName}
            onChange={handleInputChange}
          />
        </label>

        <label>
          Years in Operation
          <input
            type="text"
            placeholder="Years in Operation"
            name="yearsInOperation"
            value={formDatas.yearsInOperation}
            onChange={handleInputChange}
          />
        </label>

        <label>
          Registration Number
          <input
            type="text"
            placeholder="Registration Number"
            name="registrationNumber"
            value={formDatas.registrationNumber}
            onChange={handleInputChange}
          />
        </label>

        <label>
          Funding Source
          {isFetchingFundingSources ? (
           <Skeleton height={40} width="100%" />
          ) : (
            <div className="custom-select-container" ref={fundingSourceRef}>
              <button 
                type="button"
                className="custom-select-button"
                onClick={toggleFundingSourceDropdown}
              >
                {formDatas.fundingSource || "Choose Funding Source"}
              </button>
              {isFundingSourceOpen && (
                <div className="custom-select-dropdown show">
                  <div className="custom-select-search">
                    <input
                      type="text"
                      placeholder="Search funding sources..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  {filteredFundingSources.length > 0 ? (
                    filteredFundingSources.map((source, index) => (
                      <div
                        key={index}
                        className={`custom-select-option ${formDatas.fundingSource === source ? 'selected' : ''}`}
                        onClick={() => handleFundingSourceSelect(source)}
                      >
                        {source}
                      </div>
                    ))
                  ) : (
                    <div className="custom-select-option">No funding sources available</div>
                  )}
                </div>
              )}
            </div>
          )}
        </label>

        <label>
          Website
          <input
            type="text"
            placeholder="Website"
            name="website"
            value={formDatas.website}
            onChange={handleInputChange}
          />
        </label>

        <label>
          Phone Number
          <PhoneInput
            country={'ng'}
            value={phoneNumber}
            onChange={handlePhoneChange}
            inputProps={{
              name: 'phoneNumber',
              required: true,
              autoFocus: true
            }}
            containerClass="phone-input-container"
            inputClass="phone-input"
            buttonClass="phone-input-button"
            dropdownClass="phone-input-dropdown"
            searchClass="phone-input-search"
          />
        </label>

        <label>
          Additional Phone Number
          <PhoneInput
            country={'ng'}
            value={additionalPhoneNumber}
            onChange={handleAdditionalPhoneChange}
            inputProps={{
              name: 'additionalPhoneNumber',
              required: false
            }}
            containerClass="phone-input-container"
            inputClass="phone-input"
            buttonClass="phone-input-button"
            dropdownClass="phone-input-dropdown"
            searchClass="phone-input-search"
          />
        </label>

        <button type="submit">Next</button>
      </form>
    </div>
  );
};

export default Customeractivationpage1;
